import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get, MICROSERVICES } from 'api';
import { IRemunerationGoal } from 'interfaces/RemunerationGoal';
import {
  IMyKnownError,
  REQUEST_LIFE_CICLE,
  IPaginatedListResponse,
  IListRequestParams,
} from 'interfaces/requests';

import endpoints from './endpoints';
import { IRemunerationGoalListState } from './interfaces';

export const listRemunerationGoalAction = createAsyncThunk<
  IPaginatedListResponse<IRemunerationGoal>,
  IListRequestParams,
  { rejectValue: IMyKnownError }
>('listRemunerationGoal/fetch', async (payload, { rejectWithValue }) => {
  try {
    const result = await get<IPaginatedListResponse<IRemunerationGoal>>(
      MICROSERVICES.STRATEGIES,
      {
        url: endpoints.listRemunerationsGoal(),
        params: payload,
      },
    );
    return {
      count: result.data.count,
      values: result.data.values.map((value) => ({ ...value, id: value._id })),
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

const initialState: IRemunerationGoalListState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  errorMessage: '',
  list: [],
  count: 0,
};

const remunerationGoalListSlice = createSlice({
  name: 'remunerationGoalList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listRemunerationGoalAction.fulfilled, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      state.errorMessage = '';
      state.list = action.payload.values;
      state.count = action.payload.count;
      return state;
    });
    builder.addCase(listRemunerationGoalAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
    builder.addCase(listRemunerationGoalAction.rejected, (state, action) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
      state.errorMessage = action.payload?.message || '';
      return state;
    });
  },
});

const { reducer } = remunerationGoalListSlice;
export default reducer;
